import React from 'react';
import Section from '../Section';
import { RAID_INTRO } from '../content';
import styles from './RaidIntro.module.css';

const RAID_WORDMARK_SRC = `${process.env.PUBLIC_URL}/assets/images/raid2026/logo_raid_wordmark.svg`;

function renderLines(lines) {
  return lines.map(line => (
    <span key={line} className={styles.line}>
      {line}
    </span>
  ));
}

export default function RaidIntro() {
  return (
    <Section
      id="raid-intro"
      title="RAIDとは？"
      eyebrow="WHAT IS RAID?"
      containerClassName="mx-auto w-full max-w-4xl"
      className="pt-8 sm:pt-12"
    >
      <div className={styles.panel}>
        <img
          src={RAID_WORDMARK_SRC}
          alt=""
          aria-hidden="true"
          className={styles.watermark}
          loading="lazy"
          decoding="async"
        />
        <p className={styles.lead}>{renderLines(RAID_INTRO.lead)}</p>
        <div className={styles.copy}>
          {RAID_INTRO.paragraphs.map(lines => (
            <p key={lines.join('')}>{renderLines(lines)}</p>
          ))}
        </div>
        <p className={styles.closing}>{renderLines(RAID_INTRO.closing)}</p>
      </div>
    </Section>
  );
}
